export enum ShareNumbersType {
  VANILLA = 'VANILLA',
}

export class ShareNumbers {
  // For future proofing. Operations might depned on this.
  type?: ShareNumbersType;

  // starting number
  from: any; //number;
  // up to but not including
  to: any; // number

  // UNIX time stamp (lets not mess with dates)
  // time you but the shares.
  timeStamp: any; // number;
  eventRef: any; // string
}

export type ShareNumbersEventRef = string;
